export default function () {
    return {
        data:{},
        dataDefault: {
            id: '',
            descricao: '',
            label: '',
            status: 'A',
            ordem: '',
            link: '',
            icone: '',
            id_menu_superior: '',
            master:'S'           
        },
        disableForm: false,
        menus:[],
        menusTabela:[],
        pagination:{},
        tipoMenu:[],
        enumStatus:[],
    }
  }
  